// FTALegend.tsx — Canvas legend panel for FTA editor (CC ≤ 4)
import React from 'react';
import { Palette } from 'lucide-react';
import clsx from 'clsx';
import { FTANodeType } from '../../types/fta.types';
import { TYPE_COLORS } from './ftaPaletteConfig';
import { DisplayMode } from './FTAToolbar';

const LEGEND_ENTRIES: [string, string][] = [
    [FTANodeType.TOP_EVENT,          'Top Event'],
    [FTANodeType.INTERMEDIATE_EVENT, 'Intermediate'],
    [FTANodeType.BASIC_EVENT,        'Basic Event'],
    [FTANodeType.AND_GATE,           'AND Gate'],
    [FTANodeType.OR_GATE,            'OR Gate'],
    [FTANodeType.HOUSE_EVENT,        'House Event'],
];

const BASIC = { fill: '#f1f5f9', stroke: '#475569' };

interface Props { isDark: boolean; displayMode: DisplayMode; }

const FTALegend: React.FC<Props> = ({ isDark, displayMode }) => {
    const surface = isDark ? 'bg-slate-800/90 border-slate-700 text-white' : 'bg-white/90 border-slate-200 text-slate-700';
    const muted   = isDark ? 'text-slate-400' : 'text-slate-500';

    return (
        <div className={clsx('p-3 rounded-xl border shadow-lg text-xs', surface)}>
            <p className={clsx('font-bold mb-2 border-b pb-1', isDark ? 'border-slate-600' : 'border-slate-200')}>
                Symbol Legend
            </p>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                {LEGEND_ENTRIES.map(([type, label]) => {
                    const c = displayMode === 'colorful' ? (TYPE_COLORS[type] ?? BASIC) : BASIC;
                    return (
                        <div key={type} className="flex items-center gap-1.5">
                            <div className="w-3 h-3 rounded border-2 shrink-0"
                                style={{ backgroundColor: c.fill, borderColor: c.stroke }} />
                            <span className={muted}>{label}</span>
                        </div>
                    );
                })}
            </div>
            <div className={clsx('mt-2 pt-2 border-t flex items-center gap-1.5', isDark ? 'border-slate-700' : 'border-slate-200')}>
                <Palette size={9} className="text-indigo-500" />
                <span className="font-semibold capitalize text-indigo-600 text-[10px]">{displayMode} mode</span>
            </div>
        </div>
    );
};

export default FTALegend;
